Namespace 'Customer.Views.Activity'

class Customer.Views.Activity.SingleElementColumnView extends Backbone.View
  className: 'content-type-header'

  initialize: ({subtype, isSelected}) ->
    @subtypeCheckboxView = new Customer.Views.Activity.SubtypeCheckboxView
      subtype: subtype
      isSelected: isSelected

  render: ->
    @$el.append @subtypeCheckboxView.render().el
    @
